import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { RouteService } from '../route.service'
import { FormControl } from '@angular/forms';
import { ProgressSpinnerMode, ThemePalette } from '@angular/material';

@Component({
  selector: 'app-route-table',
  templateUrl: './route-table.component.html',
  styleUrls: ['./route-table.component.scss']
})
export class RouteTableComponent implements OnInit {

  dataSource: any;
  data_loaded = false;
  displayedColumns: string[] = ['id', 'name', 'union' ,'session','order_expiry_time'];
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 100;
  
  nameFilter = new FormControl('');
  filterValues = {
    id: '',
    name: '',
    session: '',
  };
  constructor(private global: GlobalService, private http : HttpService, public routeService: RouteService) { 
    this.global.set_master_page_title = 'Route';
    this.getRoute();
    this.routeService.downloadRoute.subscribe((route) => {
      console.log(route);
      if (route) {
        this.getRoute();
      }
    });
  }

  getRoute() {
    this.http.getRoute().subscribe((data: Route[]) => {
      console.log(data);
      this.dataSource = new MatTableDataSource<Route>(data);
      this.dataSource.sort = this.sort;
      this.dataSource.data = data;
      this.dataSource.filterPredicate = this.createFilter();
      this.data_loaded = true;
    }, (error) => {
      this.data_loaded = true;
      console.log(error);
    });
  }

  registerRoute() {
    this.showRouteRegister();
    this.routeService.RouteUpdate.emit(null);
    this.routeService.set_route_data = null;
  }

  editRoute(element) {
    this.showRouteRegister();
    this.routeService.RouteUpdate.emit(element);
    this.routeService.set_route_data = element;
  }

  hideRouteRegister() {
    this.routeService.is_display_route_register_component = false;
  }

  showRouteRegister() {
    this.routeService.is_display_route_register_component = true;
  }


  ngOnInit() {
    console.log('ng funct');
    this.nameFilter.valueChanges
      .subscribe(
        name => {
          this.filterValues.name = name;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
  }

  createFilter():
  (data: any, filter: string) => boolean {
  console.log('filter')
  let filterFunction = function (data, filter): boolean {
    let searchTerms = JSON.parse(filter);
    return data.name.toString().toLowerCase().indexOf(searchTerms.name.toString().toLowerCase()) !== -1
  }
  return filterFunction;
}



}
export interface Route {
  id: number;
  name: string;
}
